import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function SearchPage() {
  const { ui } = useOrignalUi();
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [items, setItems] = useState([]);
  async function run(query) {
    if (!query || query.length < 2) return setItems([]);
    setItems((await api(`/api/search?q=${encodeURIComponent(query)}`)).items);
  }
  useEffect(() => { run(q); }, []);
  return (
    <main className="og-page" data-testid="page-search">
      <h1>{ui.searchPage.title}</h1>
      <p className="og-lead">{ui.searchPage.subtitle}</p>
      <form className="og-inline" onSubmit={(e) => { e.preventDefault(); run(q); }}>
        <input className="og-input" value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-q" />
        <button className="og-btn og-btn--primary" type="submit">{ui.app.search}</button>
      </form>
      {items.length === 0 ? <p data-testid="search-empty">{ui.searchPage.empty}</p> : null}
      <ul className="og-list">
        {items.map((item) => (
          <li key={`${item.type}-${item.id}`}><Link to={item.href}>{item.title}</Link> <small>{item.type}</small></li>
        ))}
      </ul>
    </main>
  );
}
